import { faCopy } from '@fortawesome/pro-light-svg-icons'
import { PermissionThreeKeys } from '@teinor/erp/permissions'
import PermissionChecker from '../../../../../../../baseComponents/PermissionChecker'
import { TwinIconToolTip } from '../../../../../../../baseComponents/TwinIcon'
import { OrderData } from '../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import useEditDeleteModal from '../../../../../../../utils/hooks/useEditDeleteModal'
import { getUserPermissions } from '../../../../../../../utils/reducers/getters'
import ModalBuyOrderDuplicate from './ModalBuyOrderDuplicate'

interface BuyOrderDuplicateButtonProps {
    allRowData: OrderData
    permissionTy: PermissionThreeKeys
    title: string
    id: string
    children?: React.ReactNode
}

export const BuyOrderDuplicateButton: React.FC<BuyOrderDuplicateButtonProps> = ({ allRowData, permissionTy, title, id, children }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <PermissionChecker permission='create' userPermissions={getUserPermissions(permissionTy)}>
            <div onClick={() => setOpenModal({ type: 'create', allRowData })}>
                {children ?? <TwinIconToolTip classNameIcon='hover:text-green-43 regular22' message={title} icon={faCopy} id={id} />}
            </div>
            {openModal?.type === 'create' ? <ModalBuyOrderDuplicate setOpened={() => setOpenModal({ type: 'delete', allRowData })} allRowData={allRowData} onSubmit={() => { }} /> : null}
        </PermissionChecker>
    )
}